import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=1540d9f4&"
import script from "./ProfileInfo.vue?vue&type=script&lang=ts&"
export * from "./ProfileInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports